module.exports = __webpack_public_path__ + "static/winter5-e67543d232e4c5448d582b107ba72808.jpg";